import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CreateGroup,
  UserGroupActionTypes,
  GetUsersGroups,
  AddUsersToGroup,
  UpdateGroup,
  GetGroupDetails,
  ClearDataForAddGroup,
  ClearDataForUserAdd,
} from '../store/user-groups.actions';
import { Actions } from '@ngrx/effects';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";
import { GetConfigurations } from '../../configurations/store/configurations.actions'


@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.scss']
})
export class AddGroupComponent implements OnInit, OnDestroy {

  users = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];
  addGroupForm: FormGroup;
  selectedUsers: any = [];
  action: string;
  private stopper$: Subject<void> = new Subject<void>();
  showError: boolean = false;
  validationMsg = VALIDATION_MESSAGES;
  memberValidationCount: number = 2;
  groupNameMaxLength: number = 0

  constructor(
    private _store: Store<AppState>,
    public dialogRef: MatDialogRef<AddGroupComponent>,
    public action$: Actions,
    private fb: FormBuilder,
    private notificationService: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogRef.disableClose = true;
    this.addGroupForm = this.fb.group({
      name: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
        Validators.pattern('(.*)([a-zA-Z0-9])(.*)$')
      ])],
      description: ['', Validators.maxLength(200)],
    });
  }

  ngOnInit() {
    this._store.select(state => state.userGroups.createdGroup).pipe(takeUntil(this.stopper$)).subscribe((response) => {
      if (response && Object.keys(response).length) {
        if (this.selectedUsers.length) {
          // const users = this.selectedUsers.map(user => user._id);
          // this._store.dispatch(new AddUsersToGroup(response._id, users))
          this.dialogRef.close({ 'type': 'createGroup' })
        }
      }
    });

    if (this.data) {
      this.action = this.data.action;
      this.memberValidationCount = 1;
      if (this.data.action === "editGroup") {
        this.addGroupForm.patchValue({
          name: this.data.name,
          description: this.data.description
        });
      }
    }
    this._store.select(state => state.userGroups.userAddedToGroup).pipe(takeUntil(this.stopper$)).subscribe(resp => {
      if (resp && Object.keys(resp).length) {
        if (this.data && this.data.groupId) {
          this.notificationService.success('User added to group successfully');
          this._store.dispatch(new GetGroupDetails(this.data.groupId));
          this.dialogRef.close('');
        }
      }
    });

    this._store.dispatch(new GetConfigurations());
    this._store.select(state => state.configurations.configurations).subscribe(res => {
      if (res['groupName'])
        this.groupNameMaxLength = parseInt(res.groupName.value)
    })
  }

  getMembers(event) {
    this.selectedUsers = event.selectedItems;
    //check if atleast one user is selected
    if (this.selectedUsers.length) {
      //while adding group minimum group members to be selected is 2 ,whereas while updating atleast one needs to be selected because minimun 2 is already handled while adding group and deleting last 2 members in a group is not allowed.
      if (this.selectedUsers.length < 2) {
        //if true means updating group
        if (this.data) {
          // so check if members already present
          if (this.data.members.length > 0) {
            this.showError = false;
          }
          else {
            this.showError = true;
          }
        }
        else {
          this.showError = true;
        }
      }
      else {
        this.showError = false;
      }

    } else {
      this.showError = true;
    }
  }

  addGroup() {
    if (this.selectedUsers.length > 1) {
      this.showError = false;
    } else {
      this.showError = true;
    }
    if (this.addGroupForm.valid && this.addGroupForm.controls.description.valid && !this.showError) {
      let selectedUsers = this.selectedUsers.map(({ _id }) => _id);
      const payload = { ...this.addGroupForm.value, 'users': selectedUsers || [] };
      this._store.dispatch(new CreateGroup(payload, this.selectedUsers));
    }
  }

  updateGroup() {
    const payload = this.addGroupForm.value;
    this._store.dispatch(new UpdateGroup(this.data.groupId, payload));
  }

  addMember() {
    this.showError = (!this.selectedUsers.length) ? true : false
    const users = this.selectedUsers.map(user => user._id);
    if (users.length) {
      this._store.dispatch(new AddUsersToGroup(this.data.groupId, users, this.action));
    } else {
      this.showError = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.stopper$.next();
    this._store.dispatch(new ClearDataForAddGroup())
    this._store.dispatch(new ClearDataForUserAdd())
  }
}
